import React, { useEffect, useState } from 'react';
import { usePopper } from 'react-popper';
export default function Timeline({ dots, has_rotation, rotation }) {
    const [boundary, setBoundary] = useState(null);
    return (React.createElement("div", { className: "ltg-timeline-wrap", ref: setBoundary },
        React.createElement("div", { className: 'ltg-timeline' }, dots === null || dots === void 0 ? void 0 : dots.map((dot) => React.createElement(Dot, Object.assign({ key: dot._id, boundary: boundary, rotation: has_rotation ? rotation : null }, dot))))));
}
function Dot({ date, position, text, boundary, rotation }) {
    ;
    const { size, unit } = position || {};
    const [referenceElement, setReferenceElement] = useState(null);
    const [translate, setTranslate] = useState(null);
    const [translateRef, setTranslateRef] = useState(null);
    const options = (placement) => ({
        placement,
        modifiers: [
            {
                name: 'flip',
                enabled: false
            },
            {
                name: 'offset',
                options: {
                    offset: [0, 10],
                },
            },
            {
                name: 'preventOverflow',
                options: {
                    boundary,
                },
            },
        ],
    });
    useEffect(() => {
        if (!rotation)
            return;
        if (!translateRef)
            return;
        setTranslate(translateRef.offsetWidth * .5 * Math.abs(rotation.size / 180) +
            translateRef.offsetHeight * .5 * Math.abs(rotation.size / 180));
    }, [rotation, translateRef]);
    if (rotation === null || rotation === void 0 ? void 0 : rotation.size) {
    }
    const rotation_style = rotation ? { style: { transform: `rotate(${rotation.size}deg)` } } : null;
    const translation_style = translate ? { style: { transform: `translateY(${translate}px)` } } : null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: setReferenceElement, className: "ltg-timeline-dot", style: { left: `${size}${unit}` } }),
        React.createElement(PopperWrap, { key: `${size}${unit}-top`, referenceElement: referenceElement, options: options('top') },
            React.createElement("div", { className: "ltg-timeline-date" }, date)),
        React.createElement(PopperWrap, { key: `${size}${unit}-bottom`, referenceElement: referenceElement, options: options('bottom') },
            React.createElement("div", Object.assign({}, translation_style),
                React.createElement("div", Object.assign({ ref: setTranslateRef, className: `ltg-timeline-text` }, rotation_style), text)))));
}
function PopperWrap({ referenceElement, options, children }) {
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement, Object.assign({}, options));
    return (React.createElement("div", Object.assign({ ref: setPopperElement, className: "ltg-timeline-popper ltg-timeline-popper-mobile", style: styles.popper }, attributes.popper), children));
}
